




























import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '@shared/components/displays/abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import SendProductPaymentRequestMessageDrawer from '@shared/components/modals/send-product-payment-request-message-drawer/send-product-payment-request-message-drawer.vue';

@Component({
  components: { SendProductPaymentRequestMessageDrawer },
})
export default class DisplayFieldPaymentRequest extends mixins(AbstractDisplayField) {
  showDrawer: boolean = false;

  get contactIds(): number[] {
    return [this.item?.contact_id] || [];
  }

  get selectedItemIds(): number[] {
    return [this.item?.id] || [];
  }

  get entityName(): string {
    return this.fieldConfig.entity || '';
  }

  onClick() {
    this.showDrawer = true;
  }
}
